import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { NinjaSimpleBar } from './common.js';

function useDebounce(callback, delay) {
    const callbackRef = useRef(callback);
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    return (value) => {
        setTimeout(() => {
            callbackRef.current(value);
        }, delay);
    };
}
function convertRemToPixels(rem) {
    try {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }
    catch (_a) {
        return rem * 16;
    }
}
function WheelPicker({ items, onChange, value }) {
    const itemHeight = convertRemToPixels(2.25);
    const debounceValue = 50;
    const scrollingRef = useRef();
    const wheelSimpleBarRef = useRef(null);
    const handleOnChange = useDebounce(onChange, debounceValue);
    const handleScroll = useDebounce((event) => {
        let isAnimating = false;
        if (!isAnimating) {
            isAnimating = true;
            requestAnimationFrame(() => {
                const scrollTop = Math.max(event.target.scrollTop, 0);
                const selectedElement = Math.min(Math.max(Math.floor(scrollTop / itemHeight), 0), items.length - 1);
                clearTimeout(scrollingRef.current);
                scrollingRef.current = setTimeout(() => {
                    handleOnChange(items[selectedElement].value);
                }, debounceValue);
                isAnimating = false;
            });
        }
    }, debounceValue);
    useEffect(() => {
        const itemIndex = items.findIndex((item) => item.value === value);
        if (wheelSimpleBarRef.current) {
            wheelSimpleBarRef.current.scrollTop(itemIndex * itemHeight);
        }
    }, []);
    function splitItemsByDisabled(items) {
        var _a;
        const disabledStart = [];
        const activeItems = [];
        const disabledEnd = [];
        let cursorPointer = 0;
        for (let i = 0; i <= items.length; i += 1) {
            const item = items[i];
            if (!item) {
                continue;
            }
            const isNextItemIsNotSame = (item === null || item === void 0 ? void 0 : item.isDisabled) !== ((_a = items[i + 1]) === null || _a === void 0 ? void 0 : _a.isDisabled);
            if ((item === null || item === void 0 ? void 0 : item.isDisabled) && isNextItemIsNotSame && cursorPointer === 0) {
                disabledStart.push(item);
                cursorPointer += 1;
                continue;
            }
            if ((item === null || item === void 0 ? void 0 : item.isDisabled) && !isNextItemIsNotSame && cursorPointer === 0) {
                disabledStart.push(item);
                continue;
            }
            if (!(item === null || item === void 0 ? void 0 : item.isDisabled) && !isNextItemIsNotSame && (cursorPointer === 1 || !disabledStart.length)) {
                activeItems.push(item);
                continue;
            }
            if (!(item === null || item === void 0 ? void 0 : item.isDisabled) && isNextItemIsNotSame && (cursorPointer === 1 || !disabledStart.length)) {
                activeItems.push(item);
                cursorPointer += 1;
                continue;
            }
            if (cursorPointer === 2 || !(disabledStart.length || !activeItems.length)) {
                disabledEnd.push(item);
            }
        }
        return [disabledStart, activeItems, disabledEnd];
    }
    const itemsWithDisabledSteps = splitItemsByDisabled(items);
    return (jsxs("div", { className: "flex items-center w-full relative rtl:flex-row-reverse h-[16.25rem]", onScroll: (e) => {
            e.stopPropagation();
            e.preventDefault();
        }, children: [jsx("div", { className: "absolute border-t border-b h-9 snap-center border-gray-100 w-full" }), jsx(NinjaSimpleBar, { className: "h-full w-full scrollbar-hide snap-y snap-mandatory overflow-y-scroll", scrollSnapType: "snap-y", onScroll: handleScroll, ref: wheelSimpleBarRef, dragScroll: true, fixedContent: jsx("div", { className: "absolute h-full w-full cursor-pointer", style: {
                        background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, transparent 50%, rgba(255,255,255,1) 100%)',
                        pointerEvents: 'none',
                    } }), children: jsx("div", { className: "my-28", children: itemsWithDisabledSteps.map((items, index) => {
                        return (jsx("div", { className: "flex flex-col items-center", children: items.map((item, index) => {
                                return (jsx("div", { className: `w-full h-9 flex items-center justify-center
											 ${item.isDisabled ? 'text-gray-400 snap-align-none' : 'text-black snap-center cursor-grab'} ${value === item.value && 'font-medium'}`, children: item.label }, index));
                            }) }, index));
                    }) }) })] }));
}

export { WheelPicker as default };
